valueObj